<div class="app">
  <app-loading-overlay></app-loading-overlay>
  <div class="content-wrapper">
    <app-wave-background></app-wave-background>

    <router-outlet *ngIf="enterLandingPage"></router-outlet>
  </div>
  <app-footer *ngIf="enterLandingPage"></app-footer>
</div>
